/**
 * Admin UI layer — replaces antd imports with custom components + Modal.confirm.
 */

import { Modal as ModalView } from "../components/ds/Modal";
import { Drawer as DrawerView } from "../components/ds/Drawer";
import { modalConfirm } from "./modalFacade";
import { DatePickerAnt } from "../components/ds/DatePicker";

export { message, notification } from "./notify";
export { Button } from "../components/ds/Button";
export { Input, TextArea, InputNumber } from "../components/ds/Input";
export { Select, Option } from "../components/ds/Select";
export { Switch } from "../components/ds/Switch";
export { Card } from "../components/ds/Card";
export { Row, Col } from "../components/ds/Flex";
export { Tag } from "../components/ds/Tag";
export { Divider } from "../components/ds/Divider";
export { Space } from "../components/ds/Space";
export { Upload } from "../components/ds/Upload";
export { Checkbox, CheckboxGroup } from "../components/ds/Checkbox";
export { List } from "../components/ds/List";
export { Pagination } from "../components/ds/Pagination";
export { Statistic } from "../components/ds/Statistic";
export { Table } from "../components/ds/Table";
export { Form } from "../components/ds/Form";
export { Descriptions } from "../components/ds/Descriptions";
export { Typography, Title, Text } from "../components/ds/Typography";
export { Avatar } from "../components/ds/Avatar";
export { Collapse } from "../components/ds/Collapse";
export { Timeline } from "../components/ds/Timeline";
export { Popconfirm } from "../components/ds/Popover";
export { Result } from "../components/ds/Result";
export { Progress } from "../components/ds/Progress";
export { Image } from "../components/ds/Image";
export { Layout } from "../components/ds/Layout";
export { AutoComplete } from "../components/ds/AutoComplete";
export { Tooltip } from "../components/ds/Tooltip";
export {
  PageHeader,
  PageStack,
  DataSurface,
} from "../components/admin/PageShell";

export function Modal(props) {
  return <ModalView {...props} />;
}

Modal.confirm = modalConfirm;

export function Drawer(props) {
  return <DrawerView {...props} />;
}

export const DatePicker = DatePickerAnt;
export const RangePicker = DatePickerAnt.RangePicker;
